/** Spreadsheet formula triggers. A leading one on a text cell is prefixed before quoting. */
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

/**
 * One CSV cell: quoted when it holds a comma, a quote or a line break (RFC 4180).
 * A string that starts with `=`, `+`, `-`, `@`, tab, or CR is prefixed with a
 * single quote first, so a spreadsheet does not treat it as a formula. Numbers
 * are left as digits, including a leading minus.
 */
export function csvCell(value: unknown): string {
  const text =
    typeof value === "string" && FORMULA_PREFIX.test(value)
      ? `'${value}`
      : value === null || value === undefined
        ? ""
        : String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/** Rows to one CSV document with a trailing newline; the first row is the header. */
export function toCsv(rows: ReadonlyArray<ReadonlyArray<unknown>>): string {
  return rows
    .map((row) => row.map(csvCell).join(","))
    .join("\r\n")
    .concat("\r\n");
}

/** Saves `csv` through a transient object URL; `filename` should end in `.csv`. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
